import Vue from "vue";


// import "material-icons/iconfont/material-icons.css"; // Material Icons
// import "vue-material-design-icons/styles.css";

import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax

// Theme Configurations
import "../themeConfigs";
import "./assets/scss/main.scss";
import "./assets/css/main.css";
import "./components/globalComponents";
import "./layouts/layouts";

require('./assets/css/iconfont.css')

import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

import momentDurationFormatSetup from 'moment-duration-format';
import moment from 'moment';
import 'moment/locale/pt-br';
import vuemoment from 'vue-moment';

import VueTheMask from 'vue-the-mask'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import store from "./stores";
import router from "./routers";
import App from "./App.vue";

import NavigationPlugin from "./plugins/navigationPlugin";
import LoadingPlugin from "./plugins/loadingPlugin";
import HttpServicesPlugin from "./plugins/httpServicesPlugin";
import DAOPlugin from "./plugins/DAOPlugin";


import PermissionsControlPlugin from "./plugins/permissionsControlPlugin";
import "./middlewares/clear_data_middleware";
import "./middlewares/unauthorized_middleware";

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(vuemoment, {moment});
momentDurationFormatSetup(moment)
moment.locale("pt-br")

Vue.use(VueTheMask)
Vue.use(DAOPlugin);
Vue.use(NavigationPlugin);
Vue.use(LoadingPlugin);
Vue.use(HttpServicesPlugin);

Vue.use(PermissionsControlPlugin, router);

import "./middlewares/token_timer_middleware";

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");

